import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Breadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  if (!items || items?.length === 0) return null;

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {items?.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <Icon name="ChevronRight" size={16} className="mx-2 text-muted-foreground" />
            )}
            {item?.path && index < items?.length - 1 ? (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleNavigation(item?.path)}
                className="h-auto p-1 text-muted-foreground hover:text-foreground transition-micro"
              >
                {item?.label}
              </Button>
            ) : (
              <span className={index === items?.length - 1 ? 'text-foreground font-medium' : 'text-muted-foreground'}>
                {item?.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;